import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CountryNavbar from "./CountryNavbar";
import CountryNavbarMobile from "./CountryNavbarMobile";
import CountryFirstSection from "./CountryFirstSection";
import CountrySecondSection from "./CountrySecondSection";
import CountryThirdSection from "./CountryThirdSection";
import CountryLast from "./CountryLast";
import unitedKingdom from "../../assets/images/united kingdom.png";
import france from "../../assets/images/france.png";
import dubai from "../../assets/images/dubai.png";
import { connect } from "react-redux";
import changeLogin from "../../store/Actions/LoginAction";
import CountryFirstSecion from "./CountryFirstSection";
import HomeBottomLast from "../Home/HomeBottomLast";
import { countriesApi } from "../../config/countriesApi";
import { countryApi } from "../../config/countryApi";

import CircularProgress from "@material-ui/core/CircularProgress";

function Country(props) {
  const { id } = useParams();
  const login = props.login;

  const [found, setFound] = useState(false);
  const [loader1, setLoader1] = useState(true);
  const [countryName, setCountryName] = useState(id);
  const [countryId, setCountryId] = useState(id);
  const [countryCode, setCountryCode] = useState(id);
  const [visaTypes, setVisaTypes] = useState([]);

  const [loader, setLoader] = useState(true);
  const [options1, setOptions1] = useState([
    { id: "0", label: "Loading...", isDisabled: true },
  ]);
  const [options2, setOptions2] = useState([
    { id: "0", label: "Loading...", isDisabled: true },
  ]);

  useEffect(() => {
    function getWithExpiry(key) {
      const itemStr = localStorage.getItem(key);
      if (!itemStr) {
        return null;
      }

      const item = JSON.parse(itemStr);
      const now = new Date();

      if (now.getTime() > item.expiry) {
        localStorage.removeItem(key);
        console.log("REMOVE");
        return null;
      }

      props.ChangeLogin(true);
      console.log(item.value);
      return item.value;
    }
    getWithExpiry("userData");

    const countries = async () => {
      const countries = await countriesApi();

      if (countries.data) {
        const cont = await countries.data.data;
        setLoader(false);
        setOptions1([]);
        setOptions1([{ label: "Popular Countries", isDisabled: true }]);
        cont.map((value) => {
          setOptions1((options1) => [
            ...options1,
            {
              id: value._id,
              value: value.display_name,
              label: (
                <span
                  dangerouslySetInnerHTML={{
                    __html: `<b>${value.code}</b> &nbsp; &nbsp; &nbsp; ${value.display_name}`,
                  }}
                />
              ),
            },
          ]);
        });
      } else if (countries.error) {
        console.log(countries.error);
        setLoader(false);
      }
    };
    countries();

    const country = async () => {
      const country = await countryApi(id);

      if (country.data) {
        const cont = await country.data.data;
        // setOptions2([])
        setFound(true);
        setCountryName(cont.display_name);
        setCountryId(cont._id);
        setCountryCode(cont.code);
        setVisaTypes(cont.visa_packages);
        setOptions2([]);
        (cont.visa_packages).map((value) => {
          setOptions2((options2) => [
            ...options2,
            { value: value.name, label: value.name, id: value._id },
          ]);
        });
        setLoader1(false);

      } else if (country.error) {
        console.log(country.error);
        setFound(false);
        setLoader1(false);
      }
    };
    country();

    document.title = `VisaPro | ${id}`;


  }, []);

  if (loader1) {
    return (
      <div style={{ heigth: "100vh" }}>
        <CountryNavbar countryName={countryName} />
        <div
          style={{
            height: "70vh",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress style={{ color: "#000000" }} />
        </div>
      </div>
    );
  }

  return (
    <>
      {found ? (
        <div>
          <CountryNavbar countryName={countryName} login={props.login} />
          <CountryFirstSecion
            countryName={countryName}
            countryId={countryId}
            countryCode={countryCode}
            options2={options2}
            options1={options1}
            loader={loader}
            visaTypes={visaTypes}
            selectedCountry={props.selectedCountry}
          />
          {/* <CountrySecondSection /> */}
          <CountryThirdSection />
          <CountryLast />
          <HomeBottomLast />
        </div>
      ) : (
        <div
          style={{
            height: "100vh",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <h1>Page Not Found</h1>
        </div>
      )}
    </>
  );
}

const mapStateToProps = (state) => ({
  login: state.Login.login,
});

const mapDispatchToProp = (dispatch) => ({
  ChangeLogin: (login) => dispatch(changeLogin(login)),
});

export default connect(mapStateToProps, mapDispatchToProp)(Country);

{
  /* <CountryNavbarMobile countryName={countryName} /> */
}
